export class UnderwritingDocExpirationSettingsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getUnderwritingSettings() {
    return this.#http.get(`/api/document-expiration-settings`);
  }

  async editUnderwritingSettings(body) {
    return this.#http.put(`/api/document-expiration-settings`, body);
  }
}
